/**
 * Time formatting utilities for timetable display
 * Converts 24-hour format (HH:mm) to 12-hour format with AM/PM
 */

/**
 * Convert HH:mm time string to 12-hour format with AM/PM
 * Rounds to the nearest second to clean up decimal precision
 * @param time - Time string in HH:mm or HH:mm.sss format (e.g., "14:30" or "14:30.666")
 * @returns Formatted time string (e.g., "2:30pm")
 */
export function formatTimeTo12Hour(time: string): string {
  const [hours, minutesPart] = time.split(':');
  const hour = parseInt(hours, 10);
  
  // Handle decimal minutes by rounding to nearest second
  const minutesDecimal = parseFloat(minutesPart || '0');
  const minutesRounded = Math.round(minutesDecimal);
  const minutes = String(minutesRounded).padStart(2, '0');
  
  const period = hour >= 12 ? 'pm' : 'am';
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  return `${displayHour}:${minutes}${period}`;
}

/**
 * Format time with proper spacing and capitalization
 * Rounds to the nearest second to clean up decimal precision
 * @param time - Time string in HH:mm or HH:mm.sss format
 * @returns Formatted time string (e.g., "2:30 PM")
 */
export function formatTimeTo12HourFormal(time: string): string {
  const [hours, minutesPart] = time.split(':');
  const hour = parseInt(hours, 10);
  
  // Handle decimal minutes by rounding to nearest second
  const minutesDecimal = parseFloat(minutesPart || '0');
  const minutesRounded = Math.round(minutesDecimal);
  const minutes = String(minutesRounded).padStart(2, '0');
  
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  return `${displayHour}:${minutes} ${period}`;
}

